import { render, staticRenderFns } from "./EditorProfileEmail.vue?vue&type=template&id=6797d01a&scoped=true&"
import script from "./EditorProfileEmail.vue?vue&type=script&lang=js&"
export * from "./EditorProfileEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6797d01a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6797d01a')) {
      api.createRecord('6797d01a', component.options)
    } else {
      api.reload('6797d01a', component.options)
    }
    module.hot.accept("./EditorProfileEmail.vue?vue&type=template&id=6797d01a&scoped=true&", function () {
      api.rerender('6797d01a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/userprofile/EditorProfileEmail.vue"
export default component.exports